<div class="main-div content-w-98">
  <div class="title-div">
    <div class="headerName report-header">
      <span>Project reporting</span>
      <!-- Temporary while the GenerateChartReport migration is verified: opens
           the new version of this screen in its own tab so the two can be
           compared. Remove together with the `chart-at-glance-v2` route. -->
      <a
        class="new-version-link"
        (click)="openNewChartAtGlance()"
        title="Opens the new chart at a glance in a new tab"
      >
        Open new version
        <i class="bi bi-box-arrow-up-right"></i>
      </a>
    </div>
  </div>
</div>

<div class="mt-2 notification" *ngIf="showIncorrectEOLNotification">
  <piqet-angular-incorrect-data-notification
    [message]="incorrectValueMessage"
    [buttonName]="incorrectBtnName"
    [componentName]="'end-of-life'"
    (eolAction)="eolAction($event)"
  ></piqet-angular-incorrect-data-notification>
</div>
<div class="mt-2 notification" *ngIf="showIncorrectFillingNotification">
  <piqet-angular-incorrect-data-notification
    [message]="incorrectFillingValueMessage"
    [componentName]="'fill-data-list'"
    [buttonName]="incorrectFillingBtnName"
    (eolAction)="eolAction($event)"
  ></piqet-angular-incorrect-data-notification>
</div>

<div [formGroup]="reportChartForm">
  <div class="row">
    <div class="dropdowns-div col-4">
      <div class="subTitleName">
        <span>Chart at a glance</span>
      </div>
      <div>
        <div class="row scenarios-div">
          <div class="col-12">
            <p class="note-div gray-font">Select up to 6 scenarios to compare</p>
          </div>
          <div class="col-12 ng-select-div reportGenerationDrd chartAtGlanceDrp">
            <ng-select
              [clearable]="false"
              #scenarios
              formControlName="scenarios"
              [items]="productPackageScenarioItems"
              [searchable]="false"
              bindLabel="name"
              bindValue="idStr"
              [searchFn]="commonInputSearch"
              [multiple]="true"
              (change)="scenarioSelected($event)"
              [maxSelectedItems]="6"
              placeholder="Scenarios"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    class="search"
                    placeholder="Search..."
                    (input)="scenarios.filter($any($event.target).value)"
                    type="text"
                    class="form-control search-input"
                    id="inputValidation"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item?.name }}</div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="generated && reportChartForm.controls['scenarios']?.invalid"
              class="input-error"
            >
              Please select scenarios for comparision.
            </div>
          </div>
        </div>

        <!-- Chart type & Impact Category -->
        <div class="row">
          <div class="col-6 ng-select-div reportGenerationDrd">
            <label
              *ngIf="
                reportChartForm.controls['chartType']?.value ||
                reportChartForm.controls['impactCategory']?.value
              "
              class="sub-header-drpdown pb-2"
              >Chart type
            </label>
            <label
              *ngIf="
                !reportChartForm.controls['chartType']?.value &&
                reportChartForm.controls['chartType']?.value
              "
              class="placeholder-sub-header pb-2"
              >Holder_text</label
            >
            <ng-select
              [clearable]="false"
              [clearOnBackspace]="false"
              (change)="chartType($event)"
              #chartTypeTmp
              formControlName="chartType"
              [items]="chartTypeItems"
              [searchable]="false"
              bindLabel="description"
              [searchFn]="commonInputSearchDis"
              [multiple]="false"
              placeholder="Chart type"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    placeholder="Search..."
                    type="text"
                    class="form-control search-input"
                    id="inputValidation"
                    (input)="chartTypeTmp.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                  {{ item.description }}
                </div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="generated && reportChartForm.controls['chartType']?.invalid"
              class="input-error"
            >
              Please select chart type
            </div>
          </div>
          <div class="col-6 ng-select-div reportGenerationDrd" *ngIf="isBarChartSelected">
            <label
              *ngIf="reportChartForm.controls['chartType']?.value"
              class="sub-header-drpdown text-padding"
              >Comparison by
            </label>
            <label
              *ngIf="
                !reportChartForm.controls['chartType']?.value &&
                reportChartForm.controls['chartType']?.value
              "
              class="placeholder-sub-header text-padding"
              >Holder_text</label
            >
            <ng-select
              [clearable]="false"
              [clearOnBackspace]="false"
              formControlName="comparision"
              #comparisionTmp
              [items]="chartCompareItems"
              [searchable]="false"
              bindLabel="description"
              class="impactCatDrp"
              [searchFn]="commonInputSearchDis"
              [multiple]="false"
              (change)="getChartCompareId($event)"
              placeholder="Comparison by"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    placeholder="Search..."
                    type="text"
                    class="form-control search-input"
                    id="inputValidation"
                    (input)="comparisionTmp.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div
                  title="{{ item?.description }}"
                  [class.disabled-option]="item?.disabled"
                  class="option-content"
                >
                  <span class="option-text-wrapper custom-option-withicon">
                    <span [ngOptionHighlight]="search">{{ item.description }}</span>
                    <!-- Crown icon for disabled features -->
                    <app-crown-icon
                      *ngIf="item?.disabled"
                      [tooltip]="'This feature is not available in your current plan'"
                      [size]="16"
                      [color]="'#9747FF'"
                      [customClass]="'popup-icon'"
                    >
                    </app-crown-icon>
                  </span>
                </div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="generated && reportChartForm.controls['comparision']?.invalid"
              class="input-error"
            >
              Please select comparison by
            </div>
          </div>
          <div class="col-6 ng-select-div reportGenerationDrd" *ngIf="!isBarChartSelected">
            <label
              *ngIf="
                reportChartForm.controls['impactCategory']?.value ||
                reportChartForm.controls['chartType']?.value
              "
              class="sub-header-drpdown truncated-text-input-quality text-padding-spiderchart"
              title="Selected impact categories"
              >Selected impact categories</label
            >
            <ng-select
              [clearable]="false"
              [clearOnBackspace]="false"
              formControlName="impactCategory"
              [compareWith]="compareFn"
              #impact
              [items]="chartImpactCategoryItems"
              [searchable]="false"
              bindLabel="name"
              class="impactCatDrp"
              [searchFn]="commonInputSearch"
              [multiple]="false"
              placeholder="Select impact categories"
              (change)="getImpactCatogaryId($event)"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    placeholder="Search..."
                    type="text"
                    class="form-control search-input"
                    (input)="impact.filter($any($event.target).value)"
                    id="inputValidation"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="generated && reportChartForm.controls['impactCategory']?.invalid"
              class="input-error"
            >
              Please select impact categories
            </div>
          </div>
        </div>

        <!-- Indicator List -->
        <ng-container
          *ngIf="
            (isBarChartSelected || (!isBarChartSelected && isCustomInclude)) &&
            reportTypeId != ReportTypeEnum.PEF_Categories_tox &&
            reportTypeId != ReportTypeEnum.PEF_Categories_without_tox
          "
        >
          <div class="row">
            <div class="col-12">
              <label class="sub-header-drpdown pb-2"
                >Categories to include
                <!-- <img class="questionImage" src="./assets/icons/grey-question-icon.svg" width="17" height="16" alt="">  -->
              </label>
            </div>
            <div class="col-12 ng-select-div reportGenerationDrd">
              <ng-select
                *ngIf="isBarChartSelected"
                formControlName="categoryInclude"
                [clearable]="false"
                [clearOnBackspace]="false"
                [compareWith]="compareFn"
                #category
                [items]="indicatorItems"
                #categories
                [searchable]="false"
                bindLabel="name"
                [searchFn]="commonInputSearch"
                [multiple]="false"
                (change)="selectedCategory($event)"
                placeholder="Categories to include"
              >
                <ng-template ng-header-tmp>
                  <div class="has-feedback">
                    <input
                      placeholder="Search..."
                      type="text"
                      class="form-control search-input"
                      (input)="categories.filter($any($event.target).value)"
                      id="inputValidation"
                    />
                    <span class="form-control-feedback">
                      <i class="fa fa-search icon"></i>
                    </span>
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                  <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                </ng-template>
              </ng-select>
              <ng-select
                *ngIf="!isBarChartSelected && isCustomInclude"
                [compareWith]="compareFn"
                #category
                [clearable]="false"
                formControlName="categoryInclude"
                [items]="indicatorItems"
                [searchable]="false"
                bindLabel="name"
                [searchFn]="commonInputSearch"
                class=""
                [ngClass]="
                  reportChartForm.controls['categoryInclude'].value?.length > 2
                    ? 'multi-select '
                    : ''
                "
                [multiple]="true"
                placeholder="Categories to include"
                (change)="catogorySelected($event)"
              >
                <ng-template ng-header-tmp>
                  <div class="has-feedback">
                    <input
                      placeholder="Search..."
                      type="text"
                      class="form-control search-input"
                      (input)="category.filter($any($event.target).value)"
                      id="inputValidation"
                    />
                    <span class="form-control-feedback">
                      <i class="fa fa-search icon"></i>
                    </span>
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                  <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                </ng-template>
              </ng-select>
              <div
                *ngIf="generated && reportChartForm.controls['categoryInclude']?.invalid"
                class="input-error"
              >
                Please select categories to include
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <div
      class="mainChatDiv col-8"
      *ngIf="
        (isBarChartSelected && generated && componentItemsArray.length > 0) ||
        (!isBarChartSelected && generated && componentItemsArray.length > 0)
      "
    >
      <div
        class="canvas d-flex justify-content-center"
        *ngIf="componentItemsArray.length > 0 && setChartTypeId == 3"
        style="height: 500px"
      >
        <div class="text-center">
          <piqet-angular-radar-chart
            [spiderChartData]="componentItemsArray"
            [chartOpacity]="chartOpacity"
          ></piqet-angular-radar-chart>
        </div>
      </div>
      <div class="canvas" *ngIf="componentItemsArray.length > 0 && setChartTypeId == 2">
        <div class="custom-btn-group" *ngIf="isPEFResults">
          <div class="btn-group mr-2" role="group" aria-label="First group">
            <button
              type="button"
              class="btn btn-secondary"
              [ngClass]="
                selectedPEFType != 'Weighted' ? ' modelBtn  purpleBtnHoverEffect' : 'cancelBtn'
              "
              (click)="changePEFCategories('Normalized')"
            >
              Normalized
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              [ngClass]="
                selectedPEFType == 'Weighted' ? ' modelBtn  purpleBtnHoverEffect' : 'cancelBtn'
              "
              (click)="changePEFCategories('Weighted')"
            >
              Weighted
            </button>
          </div>
        </div>
        <div>
          <piqet-angular-bar-chart
            [chartData]="componentItemsArray"
            [chartOpacity]="chartOpacity"
            [title]="topIndicatorName"
            [indicatorsName]="indicatorsName"
            [chartType]="generatedChartType"
            [selectedPEFType]="selectedPEFType"
            [chartHeight]="glanceChartHeight"
            [maxChartHeight]="glanceChartHeight"
            [isChartNormalized]="isChartNormalized"
            (changePEFCategoriesEmit)="changePEFCategories($event)"
          ></piqet-angular-bar-chart>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="dropdowns-div col-4">
      <div class="row">
        <div class="col-12 ng-select-div reportGenerationDrd">
          <label
            *ngIf="reportChartForm.controls['functionalUnit']?.value"
            class="sub-header-drpdown pb-2"
            >Functional unit</label
          >
          <ng-select
            [clearable]="false"
            [clearOnBackspace]="false"
            (change)="functionalUnit($event)"
            #fUnit
            formControlName="functionalUnit"
            [items]="functionalUnitItems"
            [searchable]="false"
            bindLabel="name"
            [searchFn]="commonInputSearch"
            [multiple]="false"
            placeholder="Functional unit"
          >
            <ng-template ng-header-tmp>
              <div class="has-feedback">
                <input
                  placeholder="Search..."
                  type="text"
                  class="form-control search-input"
                  (input)="fUnit.filter($any($event.target).value)"
                  id="inputValidation"
                />
                <span class="form-control-feedback">
                  <i class="fa fa-search icon"></i>
                </span>
              </div>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
              <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
            </ng-template>
          </ng-select>
          <div
            *ngIf="generated && reportChartForm.controls['functionalUnit']?.invalid"
            class="input-error"
          >
            Please select functional unit
          </div>
        </div>
        <div
          class="col-12 ng-select-div reportGenerationDrd"
          *ngIf="isEquivalentFunctionUnitSelected"
        >
          <label
            *ngIf="reportChartForm.controls['baselineFunctional']?.value"
            class="sub-header-drpdown pb-2"
            >Baseline for functional comparison</label
          >
          <ng-select
            [clearable]="false"
            [clearOnBackspace]="false"
            formControlName="baselineFunctional"
            [items]="selectedScenarios"
            [searchable]="false"
            bindLabel="name"
            #fUnitBase
            [searchFn]="commonInputSearch"
            [multiple]="false"
            (change)="baselineValue($event)"
            placeholder="Baseline for functional comparison"
          >
            <ng-template ng-header-tmp>
              <div class="has-feedback">
                <input
                  placeholder="Search..."
                  type="text"
                  class="form-control search-input"
                  (input)="fUnitBase.filter($any($event.target).value)"
                  id="inputValidation"
                />
                <span class="form-control-feedback">
                  <i class="fa fa-search icon"></i>
                </span>
              </div>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
              <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
            </ng-template>
          </ng-select>
          <div
            *ngIf="generated && reportChartForm.controls['baselineFunctional']?.invalid"
            class="input-error"
          >
            Please select baseline for functional comparison
          </div>
        </div>
      </div>

      <div id="goTOSpiderChat" class="modal-footer setBottomMargin">
        <button type="submit" (click)="onGenerate()" class="modelBtn purpleBtnHoverEffect">
          Generate
        </button>
        <!-- <button *ngIf="!(generated && packagingComponentItems.length > 0)" type="button" (click)="nextPage()"
                    class="next-btn modelBtn">Next <i class="bi bi-arrow-right checkbox-div"></i></button> -->
      </div>
    </div>
    <div
      class="mainChatDiv col-8"
      *ngIf="
        (isBarChartSelected && generated && componentItemsArray.length > 0) ||
        (!isBarChartSelected && generated && componentItemsArray.length > 0)
      "
    >
      <label style="visibility: hidden" class="sub-header-drpdown pb-2">Functional unit</label>
      <div *ngIf="generated && packagingComponentItems.length > 0">
        <div class="row d-flex justify-content-around setMainSpeedometer">
          <div class="col-md-4 text-center gauge-container">
            <div class="reportGenerationDrd">
              <ng-select
                [clearable]="false"
                [clearOnBackspace]="false"
                [items]="speedosImpactCategoryItems"
                [searchable]="false"
                #packaging1
                bindLabel="name"
                bindValue="id"
                [(ngModel)]="packagingComponent1"
                [ngModelOptions]="{ standalone: true }"
                (change)="changePackagingComponent($event, 1)"
              >
                <ng-template ng-header-tmp>
                  <div class="has-feedback">
                    <input
                      placeholder="Search..."
                      type="text"
                      class="form-control search-input"
                      id="inputValidation"
                      (input)="packaging1.filter($any($event.target).value)"
                    />
                    <span class="form-control-feedback">
                      <i class="fa fa-search icon"></i>
                    </span>
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                  <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item?.name }}</div>
                </ng-template>
              </ng-select>
            </div>
            <!-- Highcharts Gauge -->
            <piqet-angular-gauge-chart
              [pointers]="pointers"
              [max]="packagingComponentName1 == materialCircularityIndex ? 1 : 100"
              [min]="packagingComponentName1 == materialCircularityIndex ? 0.1 : 0"
              [majorUnit]="packagingComponentName1 == materialCircularityIndex ? 0.1 : 20"
              [title]="packagingComponentName1"
              [chartId]="'chart-1'"
              class="radialgauge-size chart-1"
            ></piqet-angular-gauge-chart>
            <div class="gauge-title">{{ packagingComponentName1 }}</div>
          </div>
          <div class="col-md-4 text-center gauge-container">
            <div class="reportGenerationDrd">
              <ng-select
                [clearable]="false"
                [clearOnBackspace]="false"
                [items]="speedosImpactCategoryItems"
                [searchable]="false"
                #packaging2
                bindLabel="name"
                bindValue="id"
                [(ngModel)]="packagingComponent2"
                [ngModelOptions]="{ standalone: true }"
                (change)="changePackagingComponent($event, 2)"
              >
                <ng-template ng-header-tmp>
                  <div class="has-feedback">
                    <input
                      placeholder="Search..."
                      type="text"
                      class="form-control search-input"
                      id="inputValidation"
                      (input)="packaging2.filter($any($event.target).value)"
                    />
                    <span class="form-control-feedback">
                      <i class="fa fa-search icon"></i>
                    </span>
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                  <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item?.name }}</div>
                </ng-template>
              </ng-select>
            </div>
            <!-- Highcharts Gauge -->
            <piqet-angular-gauge-chart
              [pointers]="pointers1"
              [max]="packagingComponentName2 == materialCircularityIndex ? 1 : 100"
              [min]="packagingComponentName2 == materialCircularityIndex ? 0.1 : 0"
              [majorUnit]="packagingComponentName2 == materialCircularityIndex ? 0.1 : 20"
              [title]="packagingComponentName2"
              [chartId]="'chart-2'"
              class="radialgauge-size chart-2"
            ></piqet-angular-gauge-chart>
            <div class="gauge-title">{{ packagingComponentName2 }}</div>
          </div>
          <div class="col-md-4 text-center gauge-container">
            <div class="reportGenerationDrd">
              <ng-select
                [clearable]="false"
                [clearOnBackspace]="false"
                [items]="speedosImpactCategoryItems"
                [searchable]="false"
                #packaging3
                bindLabel="name"
                bindValue="id"
                [(ngModel)]="packagingComponent3"
                [ngModelOptions]="{ standalone: true }"
                (change)="changePackagingComponent($event, 3)"
              >
                <ng-template ng-header-tmp>
                  <div class="has-feedback">
                    <input
                      placeholder="Search..."
                      type="text"
                      class="form-control search-input"
                      id="inputValidation"
                      (input)="packaging3.filter($any($event.target).value)"
                    />
                    <span class="form-control-feedback">
                      <i class="fa fa-search icon"></i>
                    </span>
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                  <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item?.name }}</div>
                </ng-template>
              </ng-select>
            </div>
            <!-- Highcharts Gauge -->
            <piqet-angular-gauge-chart
              [pointers]="pointers2"
              [max]="packagingComponentName3 == materialCircularityIndex ? 1 : 100"
              [min]="packagingComponentName3 == materialCircularityIndex ? 0.1 : 0"
              [majorUnit]="packagingComponentName3 == materialCircularityIndex ? 0.1 : 20"
              [title]="packagingComponentName3"
              [chartId]="'chart-3'"
              class="radialgauge-size chart-3"
            ></piqet-angular-gauge-chart>
            <div class="gauge-title">{{ packagingComponentName3 }}</div>
          </div>
          <div
            class="d-flex justify-content-around"
            [ngStyle]="{
              width:
                gaugeLegends.length === 2
                  ? '40%'
                  : gaugeLegends.length === 3
                  ? '60%'
                  : gaugeLegends.length === 4
                  ? '75%'
                  : gaugeLegends.length >= 5
                  ? '100%'
                  : ''
            }"
          >
            <div
              class="legend pt-4 mt-3 pb-2"
              *ngFor="let pointer of gaugeLegends"
              (click)="hidePointer(pointer)"
              [ngClass]="{ 'legend-disable': pointer.hideLegends }"
            >
              <span class="legend-dot" [style.background-color]="pointer.color"></span>&nbsp;
              {{ pointer.label }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-feature-lock
  [isDisabled]="isCheckInterpretationDisabled"
  [featureCode]="FeatureCodes.REPORTS_INTERPRETATION_SECTION"
  *ngIf="generated && packagingComponentItems.length > 0"
>
  <form [formGroup]="interpretationForm">
    <div
      class="row interpretation mt-5"
      [piqetAngularSectionAccess]="FeatureCodes.REPORTS_INTERPRETATION_SECTION"
    >
      <div class="col-sm-12" style="padding: 0px">
        <div class="form-group textarea">
          <div class="services-form desc pe-3">
            <textarea
              class="resize-textarea"
              formControlName="interpretation"
              cols="20"
              id="Description"
              name="Description"
              rows="2"
              placeholder="Interpretation"
              (change)="onSaveInterPretation()"
            ></textarea>
            <label>Interpretation</label>
          </div>
          <div
            *ngIf="
              generatedInterpretation && interpretationForm.controls['interpretation']?.invalid
            "
            class="input-error"
          >
            Interpretation is required
          </div>
        </div>
      </div>
      <div id="goTOSpiderChat" class="modal-footer setBottomMargin">
        <button type="button" class="modelBtn" (click)="onSaveInterPretation()">Save</button>
        <!-- <button *ngIf="(generated && packagingComponentItems.length > 0)" type="button" (click)="nextPage()"
                    class="next-btn modelBtn">Next <i class="bi bi-arrow-right checkbox-div"></i></button> -->
      </div>
    </div>
  </form>
</app-feature-lock>
